import axiosInstance from "@/lib/axios";
import { useMutation } from "@tanstack/react-query";

interface UniversalClinicCarePlanPreviewRequest {
  careplanIds: string[];
}

export interface CarePlanPreviewItem {
  careplanId: string;
  hasCareContent: boolean;
  markdown: string;
}

interface UniversalClinicCarePlanPreviewResponse {
  careplans: CarePlanPreviewItem[];
}

export const useUniversalClinicCarePlanPreview = () => {
  return useMutation({
    mutationFn: async (
      data: UniversalClinicCarePlanPreviewRequest,
    ): Promise<UniversalClinicCarePlanPreviewResponse> => {
      const response =
        await axiosInstance.post<UniversalClinicCarePlanPreviewResponse>(
          "/new-api/universal-clinic/careplans/preview",
          data,
        );

      return response.data;
    },
  });
};
